import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  public text = '';

  constructor() {}

  public setText(text: string) {
    this.text = text;
  }

  public clear() {
    this.text = '';
  }
}
